import { useState, useEffect, useRef } from 'react'

import './IntroSlideImage.scss'

interface IntroSlideImageProps {
  src: string
  alt: string
}

// Track which images have been loaded globally
const loadedImages = new Set<string>()

export function IntroSlideImage({ src, alt }: IntroSlideImageProps) {
  const [isLoaded, setIsLoaded] = useState(() => loadedImages.has(src))
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    // Check if image is already cached
    if (loadedImages.has(src)) {
      setIsLoaded(true)
      return
    }

    // Check if the image is already complete (cached by browser)
    if (imgRef.current?.complete && imgRef.current?.naturalHeight !== 0) {
      setIsLoaded(true)
      loadedImages.add(src)
    }
  }, [src])

  const handleLoad = () => {
    setIsLoaded(true)
    loadedImages.add(src)
  }

  return (
    <div className="intro-slide-image">
      {!isLoaded && <div className="intro-slide-image__placeholder" aria-hidden="true" />}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={`intro-slide-image__img ${isLoaded ? 'intro-slide-image__img--loaded' : ''}`}
        loading="eager"
        decoding="async"
        onLoad={handleLoad}
      />
    </div>
  )
}
